exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donate .suggestion[data-v-0759a152]{position:relative;top:-10px;font-size:12px}.oi-donate .suggestion .email[data-v-0759a152]{color:#ef4e23;cursor:pointer}.oi-donate .email small.help[data-v-0759a152]{margin:0 0 5px;position:relative;font-size:12px;top:-5px}.oi-donate .email input[data-v-0759a152]{margin-bottom:10px}.oi-donate .email .unsubscribe[data-v-0759a152]{font-size:12px;display:block}", ""]);

// exports
